import AgenciaCrud from './AgenciaCrud'
export {AgenciaCrud}
export default AgenciaCrud
